import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { Metric } from '@src/components/Admin/Metric/Metric';
import { SPEND_STATS } from '@src/graphql/queries/dashboard';
import { useLocale } from 'pe-core-frontend';
export const DashboardSpendStats = ({ client, year }) => {
    const { t, formatCurrency } = useLocale();
    const { data: spendStatsData } = useQuery(SPEND_STATS, {
        variables: {
            spec: {
                clientId: client.id,
                capYear: year,
            },
        },
    });
    // const chartData = useMemo(() => {
    //   if (!spendStatsData?.spendStats) return [];
    //   return [
    //     {
    //       name: t('Spend'),
    //       ...spendStatsData.spendStats,
    //     },
    //   ];
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [spendStatsData]);
    // const currencyFormatter = (value: number) =>
    //   formatCurrency(value, client.clientConfig!.currency, true);
    // const tooltipFormatter = (value: number, name: string) => [currencyFormatter(value), name];
    // const budget = client.clientConfig?.extraData.budget || 0;
    return (_jsx("div", { children: _jsx(Metric, { label: t('Payments approved'), values: [
                formatCurrency(spendStatsData?.spendStats?.amountSpent, client.clientConfig.currency, true),
            ] }) }));
};
